import * as CommonIcons from 'assets/common';
import { classNames } from 'utilities/Utils';
import { Box, StyledEngineProvider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cta: {
    cursor: 'pointer',
    '& path': {
      fill: theme.palette.primary.main,
    },
  },
}));
const CustomCaption = props => {
  const { date, localeUtils, onChange, showYearChangeIcon, dateLabel } = props;
  const classes = useStyles();
  const month = localeUtils.getMonths()[date.getMonth()];
  const year = date.getFullYear();
  const handleChange = (year, month) => {
    onChange(new Date(year, month));
  };
  return (
    <StyledEngineProvider injectFirst>
      <Box className="DayPicker-Caption">
        <Box className={`${classes.root}`}>
          <Box className="month-year-wrapper">
            <Box marginRight={1} component={'span'}>
              {month}
            </Box>
            <Box component={'span'}>{year}</Box>
          </Box>
          <div className="flex ml-5">
            <Box className={classes.root}>
              {showYearChangeIcon && (
                <CommonIcons.ChevronLeftTwins
                  className={classNames(classes.cta)}
                  onClick={() =>
                    handleChange(date.getFullYear() - 1, date.getMonth())
                  }
                />
              )}
              <CommonIcons.ChevronLeft
                className={classNames(classes.cta)}
                onClick={() =>
                  handleChange(date.getFullYear(), date.getMonth() - 1)
                }
              />
            </Box>
            <Box className={classes.root}>
              <CommonIcons.ChevronRight
                className={classNames(classes.cta)}
                onClick={() =>
                  handleChange(date.getFullYear(), date.getMonth() + 1)
                }
              />
              {showYearChangeIcon && (
                <CommonIcons.ChevronRightTwins
                  className={classNames(classes.cta)}
                  onClick={() =>
                    handleChange(date.getFullYear() + 1, date.getMonth())
                  }
                />
              )}
            </Box>
          </div>
        </Box>
        {dateLabel && <div className="!text-[11px]">{dateLabel}</div>}
      </Box>
    </StyledEngineProvider>
  );
};
export { CustomCaption };
